import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { Pagination } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { Form, withFormik } from 'formik';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { uid } from 'react-uid';
import _e from 'common/localeUtil';
import TextInputField from './form/TextInputField';
import GMButton from './button/GMButton';

const useStyles = makeStyles((theme) => ({
	unsplash: {
		// padding: 24
	},
	contentWrapper: {
		padding: theme.spacing(1),
		backgroundColor: theme.palette.background.paper,
		// padding: 24,
		// paddingBottom: 4
	},
	searchField: {
		color: 'black',
	},
	form: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	submitButton: {
		marginLeft: theme.spacing(1),
	},
	pagination: {
		'& a': {
			color: 'inherit',
		},
	},
	keyword: {
		margin: theme.spacing(2, 2, 2, 0),
		display: 'inline-block',
		// reset default <button> chrome (was previously an <a>)
		appearance: 'none',
		border: 0,
		background: 'none',
		padding: 0,
		font: 'inherit',
		color: 'inherit',
		cursor: 'pointer',
	},
	inputSearchWrapper: {
		flex: 1,
		'& input': {
			width: '100%',
			borderColor: '#c5c5c5',
		},
	},
	imageTileStyle: {
		width: (props) => {
			let width = 150;
			if (props.maxWidth === 'sm') {
				width = (768 - 160) / 3;
			} else if (props.maxWidth === 'md') {
				width = (960 - 160) / 3;
			} else if (props.maxWidth === 'lg') {
				width = (1280 - 160) / 4;
			} else {
				width = 150;
			}
			return width;
		},
		height: (props) => {
			let height = 110;
			if (props.maxWidth === 'sm') {
				height = (768 - 160) / 4;
			} else if (props.maxWidth === 'md') {
				height = (960 - 160) / 4;
			} else if (props.maxWidth === 'lg') {
				height = (1280 - 160) / 5;
			} else {
				height = 110;
			}
			return height;
		},
	},
}));

const unsplashKeywords = ['professional', 'background'];

const ChooseImage = ({ maxWidth, values, setFieldValue, onImageClick }) => {
	const classes = useStyles({ maxWidth });
	const searchImages = useStoreActions((actions) => actions.unsplash.searchImages);

	const images = useStoreState((state) => state.unsplash.images);
	const totalPages = useStoreState((state) => state.unsplash.totalPages);
	const searchPage = useStoreState((state) => state.unsplash.searchPage);

	const formHandleSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();
		searchImages({ inputSearchValue: values.inputSearch, searchPage: 1 });
		// setTimeout(() => {
		//   alert(JSON.stringify(values, null, 2));
		// }, 1000);
	};

	const handleClickSearchPage = (event, page) => {
		console.log('handleClickSearchPage');
		searchImages({ searchPage: page });
	};

	const onKeywordClick = (keyword) => () => {
		// console.log('onKeywordClick', values);
		setFieldValue('inputSearch', keyword);
		searchImages({ inputSearchValue: keyword, searchPage: 1 });
	};

	useEffect(() => {
		console.log('ChooseImage useEffect', searchPage);
		if (images.length === 0) {
			searchImages({ inputSearchValue: values.inputSearch, searchPage: 1 });
		}
	}, []);

	const selectImage = (imageUrl) => () => {
		onImageClick(imageUrl);
	};

	const renderImage = (imageData) => {
		const imageUrl = imageData.urls.regular;
		const imageId = uid(imageData);
		return (
			<div
				className="gjs-am-asset gjs-am-asset-image"
				key={imageId}
				id={`unsplash-${imageId}`}
			>
				<div className={classes.imageTileStyle}>
					<div
						role="presentation"
						className="gjs-am-preview"
						style={{ backgroundImage: `url('${imageUrl}')` }}
						onClick={selectImage(imageUrl)}
					/>
				</div>
			</div>
		);
	};

	const generatePagination = () => {
		// Limit to 40 pages results now
		const numPages = Math.min(totalPages, 40);
		// console.log('TCL: generatePagination total_pages', total_pages);
		if (!numPages) {
			return null;
		}

		return (
			<Pagination
				count={numPages}
				onChange={handleClickSearchPage}
				page={searchPage}
				variant="outlined"
			/>
		);
	};

	return (
		<div id="modal-unsplash" className={classes.unsplash}>
			<div className={classes.contentWrapper}>
				<Form className={classes.form} onSubmit={formHandleSubmit}>
					<div className={classes.inputSearchWrapper}>
						<TextInputField
							name="inputSearch"
							placeholder="put keyword here"
							lightBackground
							iconLeft={`fa-search`}
						/>
					</div>
					<GMButton onClick={formHandleSubmit} title={_e('search')} />
				</Form>
				<div>
					{unsplashKeywords.map((keyword) => (
						<button
							key={uid(keyword)}
							type="button"
							className={classes.keyword}
							onClick={onKeywordClick(keyword)}
						>
							{keyword}
						</button>
					))}
				</div>
			</div>

			<div className="gjs-am-assets unsplash-images-wrapper" data-el="assets">
				{images.map(renderImage)}
			</div>
			<Box pt={2} display="flex" justifyContent="center" alignItems="center">
				{generatePagination()}
			</Box>
		</div>
	);
};

ChooseImage.propTypes = {
	values: PropTypes.object,
	onImageClick: PropTypes.func,
	setFieldValue: PropTypes.func,
	maxWidth: PropTypes.string,
};

export default withFormik({
	mapPropsToValues: () => ({ inputSearch: 'background' }),

	// Custom sync validation
	validate: (values) => {
		console.log(values);
		// const errors = {};
		//
		// if (!values.name) {
		//   errors.name = 'Required';
		// }
		//
		// return errors;
	},
	// validationSchema:{Yup.object({
	//           // subdomain: Yup.string()
	//           //   .max(15, 'Must be 15 characters or less')
	//           //   .required('Required')
	//         })},

	displayName: 'ChooseImageForm',
})(ChooseImage);
